export const decode = (query: string = ''): Record<string, string> => {
  query = query.replace(/^\?/, '')
  const params = query.split('&').reduce(
    (params: Record<string, string>, part: string) => {
      if (part) {
        const [k, v = ''] = part.split('=')
        params[decodeURIComponent(k)] = decodeURIComponent(v)
      }
      return params
    },
    {} as Record<string, string>
  )
  return params
}

export const encode = (params: Record<string, string>): string => {
  const out: string[] = []
  for (const k in params) {
    if (Object.prototype.hasOwnProperty.call(params, k)) {
      out.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    }
  }
  return out.join('&')
}
